import type { OptionType } from '@/types/commonType'
export interface planType {
  plan_name: string
  price_class: string
  country_id: number | null
  city_ids: number[]
  validdate_start: string
  validdate_end: string
  branch_ids: Array<number>
  branch_all: number
  langcode: number | string
  plan_description: string
  product_guide?: string
  product_inclusion: string
  product_exclusion?: string
  trust_expire: string
  product_trusttext?: string
  policy_cancel?: string
  issue_info?: string
  product_plan: number
}

export interface priceType {
  plankey?: number
  supplier_pid: string
  plan_name: string
  price_class: string
  price_condition: string | number
  currency_id: string | number
  original_price: string | number
  sale_price_max: string | number
  total_cost: string | number
  sale_price_min: string | number
  stock: number
  product_price_id?: string
}

export type pagnationType = {
  total: number
  page: number
  per_page: number
}

export enum ProductAddaction {
  singleaadd = 0,
  mutipleadd = 1
}

export enum ProductAction {
  SUBMIT = 0,
  GOBACK = 1
}

export enum ProductStatus {
  IS_OFF = 2,
  IS_ON = 1
}

export enum priceaction {
  ADD = 2,
  DEL = 1
}

export type QuestionTextType = {
  language: number
  question_name: string
  question_description: string
  data_options: OptionType[]
}

export type QuestionType = {
  question_code: string
  question_type: number
  data_type: number
  is_required: boolean
  is_everyone: boolean
  texts: QuestionTextType[]
}

export type resourceQueryType = {
  product_id: number
  plan_id: number
  resource_id: number
}

export type CodeType = {
  code: string
  name: string
}

export type ProductType = {
  product_id: number
  image_link: string
  custom_product_no: string
  review_status: number
  reject_reason: string | null
  status: number
  type: number
  language: number
  name: string
  categories: CodeType[]
  locations: CodeType[]
  remark: string | null
  created_at: string
  updated_at: string
}

export type CategoryType = {
  code: string
  subcategories: any[]
}

export type ImageCoverType = {
  image_id: number
  source_file: string
  source_data: string | null
  is_cover: boolean
}

export type ProductTextType = {
  language: number
  name: string
  feature: string | null
  description: string | null
  inclusion: string | null
  exclusion: string | null
  instruction: string | null
  notice: string | null
  trust_issue_info: string | null
}

export type ProductDetailType = {
  product_id: number
  custom_product_no: string
  review_status: number
  reject_reason: string | null
  status: number
  type: number
  categories: CategoryType[]
  images: ImageCoverType[]
  remark: string | null
  texts: ProductTextType[]
  plans: any[]
  reviews: any[]
  created_at: string
  updated_at: string
}

export type LocationType = {
  code: string
  sublocations: string[]
}

export type BranchType = {
  merchant_id: number | string
  branches: number[]
}
